export default __webpack_public_path__ + "3ba250bc8fd34f789e2dfc7fa6a81624.jpg";